import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

aframe.registerComponent("main-menu", {
  init() {
    this.startButton = this.el.querySelector("#startButton");
  },
  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = evt.detail;
    if (newState === "MainMenu") {
      this.el.setAttribute("visible", true);
      this.el.setAttribute("paused", false);
    } else {
      this.el.setAttribute("visible", false);
      this.el.setAttribute("paused", true);
    }
  }),
  vrbuttonup: bindEvent(function(evt) {
    const buttonId = evt.target.id;
    const controls = buttonId === "beginBasic" ? "Basic" : "Advanced";

    document
      .querySelector("[game-state]")
      .setAttribute("game-state", { state: "NewGame", controls });
  })
});
